export default "__VITE_ASSET__DpFJ5Q9T__"